import { shade } from 'polished';
import styled, { css } from 'styled-components';
import { Search } from 'react-iconly';

export const Main = styled.div`
  width: 100%;
  margin: 20px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: var(--background);

  h1 {
    font-size: 3.6rem;
    font-weight: 500;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: 500;
  }

  .header-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 40px;
    button {
      width: 274px;
      height: 47px;
      margin-right: 40px;
      font-size: 1.6rem;
    }
  }
`;

export const Section = styled.div`
  background: #fcfcfc;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 20px 40px 40px 38px;

  .sectionCard {
    display: flex;
    flex-direction: column;
    align-items: left;
    text-align: left;
    margin: 20px 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: var(--table-color);
    box-shadow: 0 4px 21px -2px rgba(0, 0, 0, 0.08);

    h2 {
      color: var(--secondary);
      margin-left: 40px;
      margin-bottom: 40px;
    }
  }

  .searchBar {
    float: right;
    display: flex;
    align-items: flex-end;
    margin-top: 20px;

    > svg {
      position: absolute;
      float: right;
      width: 20px;
      height: 20px;
      margin: -10px 0 0 20px;
    }

    input {
      float: right;
      padding-left: 50px;
      width: 560px;
    }
  }

  button.allItems {
    float: right;
    width: 274px;
    height: 47px;
    background: transparent;
    border: 2px solid var(--red);
    font-size: 1.6rem;
    font-weight: 400;
    color: var(--red);
    transition: background-color 0.2s;

    &:hover {
      color: ${(shade(0.2), '#BF1E2D')};
    }
  }

  .flex-container {
    border-bottom: 1px solid var(--line);
    display: flex;
    align-items: start;
    justify-content: space-between;
    text-align: left;

    padding-right: 10px;
    margin: 5px 40px 20px 40px;

    & > div {
      height: 100%;
      width: 140px;
      display: flex;
      align-items: left;
      justify-content: left;
      text-align: left;
    }

    .item {
      color: var(--background);
    }

    button.button-status {
      width: 135px;
      height: 33px;
      background: var(--green);
      font-size: 1.4rem;
      margin-top: -5px;
      &:hover {
        background: ${(shade(0.2), '#1A7541')};
      }
    }

    button.button-pendente {
      width: 135px;
      height: 33px;
      background: var(--red);
      font-size: 1.4rem;
      margin-top: -5px;
      transition: color 0.2s;
      &:hover {
        background: ${(shade(0.2), '#BF1E2D')};
      }
    }

    button.button-plus {
      width: 38px;
      height: 38px;
      background: var(--primary);

      margin-left: 40px;
      margin-top: -10px;
      transition: color 0.2s;

      & > span {
        margin: -2px 2px 2px -6px;
        font-size: 3rem;
        font-weight: 400;

        text-align: center;
      }
      &:hover {
        background: ${(shade(0.2), '#EB5757')};
      }
    }
  }

  .bottomPedidos {
    margin: 20px 0 50px 40px;
  }
`;

const iconCSS = css`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
`;
export const SearchIcon = styled(Search)`
  ${iconCSS}
`;

export const Calender = styled.aside`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1200px;

  margin: 40px 0 70px 40px;
  color: var(--secondary);
`;
